<!--
  @component

  The text of a tooltip.

  Used alongside <TooltipContainer> and <TooltipTarget> to create
  customized tooltips when the regular <Tooltip> can't be used.

  See <TooltipContainer> for details.
-->
<svelte:options immutable />

<script lang="ts">
import type { ClassValue } from 'svelte/elements';

import type { FloatingPlacement } from '../floating';
import { type TooltipVisibility, useTooltip } from './tooltip-styles';

export let location: FloatingPlacement = 'top';
export let state: TooltipVisibility | undefined = undefined;

/** Additional CSS classes to pass to the tooltip text element. */
let extraClasses: ClassValue = '';
export { extraClasses as cx };

const { id, style, isVisible, setVisibility } = useTooltip();
let floatingElement: HTMLElement | undefined;
let arrowElement: HTMLElement | undefined;

$: setVisibility(state);
$: style.register({
  floatingElement,
  arrowElement,
  placement: location,
  auto: $isVisible,
});
</script>

<div
  bind:this={floatingElement}
  {id}
  role="tooltip"
  class:hidden={!$isVisible || !$style}
  style:top={$style?.top}
  style:left={$style?.left}
  class={[
    'z-max border-gray-9 pointer-events-none absolute top-0 left-0 w-max max-w-[250px] border whitespace-normal',
    extraClasses,
  ]}
>
  <div
    bind:this={arrowElement}
    class="bg-gray-9 absolute h-[8.5px] w-[8.5px] rotate-45"
    style:top={$style?.arrow?.top}
    style:left={$style?.arrow?.left}
    style:right={$style?.arrow?.right}
    style:bottom={$style?.arrow?.bottom}
  ></div>

  <div
    class="bg-gray-9 flex items-center gap-1 px-2 py-1 text-left text-xs break-words text-white"
  >
    <slot />
  </div>
</div>
